// extracted by mini-css-extract-plugin
export default {"innerWrapper":"finance-page_innerWrapper__SW55q","title":"finance-page_title__sQPl2","csvLink":"finance-page_csvLink__Nm4xE"};